import React from 'react';
import PropTypes from 'prop-types';
import IframeResizer from 'iframe-resizer-react';
import { IFRAME_CLASS, DEFAULT_WIDTH } from './constants';

const Iframe = ({ src, modifier, width, height, enableScrolling }) => {
  if (!src) return null;
  const modifierString = modifier ? ` ${modifier}` : '';
  const iframeClassName = `${IFRAME_CLASS}${modifierString}`;
  const defaultWidth = !width ? DEFAULT_WIDTH : {};
  return (
    <div className={iframeClassName}>
      <IframeResizer
        scrolling={enableScrolling}
        autoResize
        src={src}
        sizeHeight={!height}
        height={height}
        width={width}
        style={defaultWidth}
      />
    </div>
  );
};

Iframe.propTypes = {
  src: PropTypes.string.isRequired,
  enableScrolling: PropTypes.bool,
  modifier: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

Iframe.defaultProps = { enableScrolling: false, modifier: '', width: '', height: '' };

export default Iframe;
